// Components
import { ButtonCustom, LoaderCotizar, TextCustom, TooltipPortal } from '../../atoms';

// Assets
import Logo from '../../../assets/images/Logos/INSLogo.svg';

// Hooks
import { useCotizador } from '../../../hooks/others';
import { Link } from 'react-router-dom';

const CardResultado = ({
  all = [],
  idPlan = '',
  nombrePlan = '',
  data = '',
  index = '',
  error = false,
  pasoSiguiente = () => null,
  cotizacionesLoading = false,
  renderCoberturasCatolica = () => null,
}) => {
  const { dataCotizar, formaPagoSelect } = useCotizador();

  const existeData = () => {
    const newData = all.find(dat => dat._id === idPlan)?.data;
    if (newData) {
      data = newData;
      return true;
    } else {
      return false;
    }
  };

  const selectFormaPago = (data, formaPagoSelect) => {
    if (data && data.primas) {
      const objectPrima = data.primas.find(
        item => item.frecuenciaPago === formaPagoSelect,
      );
      return objectPrima
        ? {
          frecuenciaPago: objectPrima.frecuenciaPago,
          primaTotal: objectPrima.primaTotal,
          montoPrima: objectPrima.montoPrima,
        }
        : null;
    }
    return null;
  };

  const primaTotal = Number(selectFormaPago(data, formaPagoSelect)?.primaTotal.replace(/[^0-9.-]+/g, ''));

  return (
    <div
      className={`${error ? 'bg-card-error' : 'bg-card'
        } h-full rounded-md px-4 pt-0 relative `}
      style={{ width: 248, display: 'inline-block' }}
    >
      {error ? (
        <div className="flex text-center items-center justify-between w-full h-full fontPSemiBold color-primary text-[25px]">
          Resultado no disponible
        </div>
      ) : existeData() === false ? (
        <LoaderCotizar type="full" variant="card" tituloLoader="Cotizando..." estiloTitulo="text-center text-primary text-md fontPSemiBold" className={`texto-plan-slider-${index}`} />
      ) : (
        <>
          <div className="bg-primary-100 rounded-t-md absolute w-full left-0 py-0 px-0 flex justify-between items-baseline">
            <span className="text-primary fontPSemiBold text-sm ml-2 py-2">
              {`${(dataCotizar.seguro.codigo === 'SEG-PLENI' || dataCotizar.seguro.codigo === 'SEG-PLENI-HILC') ? nombrePlan : "Plan " + (data.orden ? data.orden : index + 1)}`}
            </span>
            {/* {(dataCotizar.seguro.codigo === 'SEG-V' && primaTotal > 80) &&
              <TooltipPortal
                title="Sala VIP"
                content="Acceso a la sala de espera VIP del aeropuerto internacional Juan Santamaría. Disponible hasta agotar existencias."
              />
            } */}
          </div>
          <div
            className={
              dataCotizar.seguro.codigo === 'SEG-V'
                ? 'mt-14 pt-1 text-center border-b sticky top-16 bg-white z-10 pb-[38px]'
                : '  mt-14 pt-1 text-center border-b sticky top-16 bg-white z-10 '
            }
          >
            <div className="h-[60px]">
              <img
                src={data?.aseguradora?.logo || Logo}
                alt="Imagen de aseguradora"
                width={150}
                className="mx-auto w-100"
              />
            </div>
            <TextCustom
              text={data.codigoComercial}
              component="p"
              className="fontPRegular color-primary text-xs -mt-[5px]"
            />

            {formaPagoSelect !== 'Anual' ? (
              <div className="flex flex-col items-center gap-1 my-5 mb-[55px]">
                <span className="text-primary text-2xl fontPSemiBold font-semibold">
                  {selectFormaPago(data, formaPagoSelect)?.montoPrima || ''}
                </span>

                <span className="text-sm">{`Cuota ${formaPagoSelect}`}</span>
              </div>
            ) : (
              <div className="pb-[50px]">
                <TextCustom
                  text={selectFormaPago(data, formaPagoSelect).primaTotal ?? ''}
                  component="p"
                  className="pt-5 px-2 fontPSemiBold color-primary text-2xl"
                />
                <TextCustom
                  text="Prima total"
                  component="p"
                  className="pt-0 fontPRegular text-base"
                />
                <TextCustom
                  text="(IVA Incluido)"
                  component="p"
                  className="pt-0 fontPRegular text-xs text-gray-text"
                />
              </div>
            )}
          </div>

          {dataCotizar.seguro.formasPago && formaPagoSelect !== 'Anual' ? (
            <div className="flex flex-col items-center gap-0 border-b py-3">
              <span className="text-sm font-semibold">
                {selectFormaPago(data, formaPagoSelect).primaTotal ?? ''}
              </span>
              <span className="text-xs">Prima Total Anual</span>
              <span className="text-[10px] text-gray-text">(IVA Incluido)</span>
            </div>
          ) : null}

          <div
            className={`text-center ${formaPagoSelect == 'Anual' && (dataCotizar.seguro.codigo === 'SEG-PLENI' || dataCotizar.seguro.codigo === 'SEG-PLENI-HILC') ? 'mt-7' : 'mt-1'}`}
          >
            {data?.coberturas.map((resultado, index) => {
              // Verificar si resultado?.descripcion es cero o está vacío
              const esCero = /^\$0\.00|₡0\.00|\$0,00|₡0,00$/.test(
                resultado?.descripcion,
              );

              // Si es cero y el código es '78O' o '77P', mostrar 'Amparado'
              if (
                esCero &&
                (resultado?.codigo === '78O' ||
                  resultado?.codigo === '77P' ||
                  resultado?.codigo === '78B' ||
                  resultado?.codigo === '78C')
              ) {
                return (
                  <TextCustom
                    text="Amparado"
                    component="div"
                    className={`py-[34px] px-2 ${index + 1 !== data?.coberturas.length && 'border-b'
                      } fontPSemiBold text-sm`}
                    key={resultado?.codigo}
                  />
                );
              }

              // Si no es cero, mostrar la descripción original
              if (!esCero) {
                if (dataCotizar.seguro.codigo === 'SEG-PLENI-HILC') {
                  const aux = resultado?.descripcion.split('/').map(e => e.trim());
                  return (renderCoberturasCatolica(aux, index, data, resultado));
                } else {
                  return (
                    <TextCustom
                      text={resultado?.descripcion}
                      component="div"
                      className={`py-[34px] px-2 ${index + 1 !== data?.coberturas.length && 'border-b'
                        } fontPSemiBold text-sm`}
                      key={resultado?.codigo}
                    />
                  );
                }
              }

              // Si el resultado es cero y el código no es '78O' ni '77P', no renderizar nada
              return null;
            })}
          </div>

          <div className="text-center py-10">
            <ButtonCustom
              text={`${data?.pasos ? 'Comprar' : 'Solicitar'}`}
              width="160px"
              className="fontPSemiBold"
              onClick={() => pasoSiguiente(data, idPlan)}
              disabled={cotizacionesLoading}
            />
          </div>
          <Link
            to={data?.linkCondiciones}
            className="fontPRegular color-primary text-sm flex justify-center underline cursor-pointer"
            target="_blank"
          >
            Condiciones Generales
          </Link>
        </>
      )}
    </div>
  );
};

export default CardResultado;
